module.exports = __webpack_public_path__ + "static/img/img-10.54b633b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/i/img-10.jpg
// module id = 93
// module chunks = 0